module.exports = __webpack_public_path__ + "static/img/cont38.514606a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/news/cont38.jpg
// module id = /WAI
// module chunks = 1